// 사용자 정보 API

import HTTP from 'apiDefault'

// 사용자 정보 상세
export const get = (accountID, companyID) => {
  return HTTP.get(`/user/${accountID}/detail/${companyID}`
    , { headers: { Authorization: window._VUE_STATE.header } },
  )
}

// 사용자 추가
export const add = (accountID, data) => {
  return HTTP.post(`/user/${accountID}/add`,
    data,
    { headers: { Authorization: window._VUE_STATE.header } },
  )
}

// 사용자 수정
export const update = (accountID, data) => {
  return HTTP.post(`/user/${accountID}/update`,
    data,
    { headers: { Authorization: window._VUE_STATE.header } },
  )
}

// 사용자 목록
export const list = (accountID, page, pageSize) => {
  if (!pageSize) {
    pageSize = 25
  }
  if (!page) {
    page = 0
  }
  return HTTP.get(`/user/${accountID}/list?page=${page}&size=${pageSize}`,
    { headers: { Authorization: window._VUE_STATE.header } },
  )
}

// 권한 목록
export const authList = (accountID) => {
  return HTTP.get(`/user/${accountID}/auth_list`,
    { headers: { Authorization: window._VUE_STATE.header } },
  )
}



// WEBPACK FOOTER //
// ./src/api/user.js